import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSeriesList, getSeriesDetail, startPrewrittenStory } from '../api/library';

export function useSeriesList(childId) {
  return useQuery({
    queryKey: ['librarySeries', childId],
    queryFn: () => getSeriesList(childId),
    enabled: !!childId,
    staleTime: 60_000,
    select: (data) => data?.series || [],
  });
}

export function useSeriesDetail(seriesId, childId) {
  return useQuery({
    queryKey: ['librarySeriesDetail', seriesId, childId],
    queryFn: () => getSeriesDetail(seriesId, childId),
    enabled: !!seriesId && !!childId,
    staleTime: 60_000,
  });
}

export function useStartPrewrittenStory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templateId, childId }) => startPrewrittenStory(templateId, childId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['librarySeries'] });
      queryClient.invalidateQueries({ queryKey: ['librarySeriesDetail'] });
    },
  });
}
